import { render, staticRenderFns } from "./QR-code-img.vue?vue&type=template&id=65cc3aa9&scoped=true&"
import script from "./QR-code-img.vue?vue&type=script&lang=js&"
export * from "./QR-code-img.vue?vue&type=script&lang=js&"
import style0 from "./QR-code-img.vue?vue&type=style&index=0&id=65cc3aa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cc3aa9",
  null
  
)

export default component.exports